var _ellipse, _ellipse2, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _rect2, _rect3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 143,
    viewBox: "0 0 122 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5917,
    cy: 79.7445,
    rx: 60.5917,
    ry: 62.5961,
    fill: "#DBF0FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2463_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 38,
    width: 107,
    height: 105
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.2671,
    cy: 90.4894,
    rx: 52.7671,
    ry: 52.091,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2463_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0557 122.472C48.3767 121.989 48.7155 121.484 49.0924 120.925C49.5542 120.24 51.1538 117.881 51.4324 117.469C52.3389 116.127 53.0145 115.112 53.6243 114.169C55.0818 111.917 54.4374 108.909 52.1849 107.452C49.9324 105.994 46.9249 106.639 45.4674 108.891C44.899 109.77 44.2552 110.737 43.3815 112.03C43.1104 112.432 41.5076 114.795 41.0367 115.494C40.6495 116.068 40.2999 116.589 39.9671 117.089C38.0977 119.899 36.7065 122.117 35.5837 124.138L35.3359 124.654C33.0682 130.181 31.9458 134.409 31.606 138.828C31.3139 142.624 31.5387 145.995 32.3806 153.068C32.6978 155.732 35.1146 157.634 37.7786 157.317C40.4427 157 42.3453 154.583 42.0281 151.919C41.2588 145.457 41.0645 142.543 41.293 139.573C41.5425 136.328 42.3822 133.121 44.2152 128.609C45.1681 126.917 46.3991 124.961 48.0557 122.472Z",
    fill: "#EBBAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3345 118.513C40.9392 111.376 46.9086 105.891 54.071 105.891H68.09C75.208 105.891 81.1556 111.31 81.8162 118.397L83.5441 136.938L82.3625 163.528L40.0864 164.316L38.7734 136.938L40.3345 118.513Z",
    fill: "#D04040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7562 117.018C66.8338 117.018 70.95 112.852 70.95 107.712C70.95 102.573 66.8338 98.4062 61.7562 98.4062C56.6787 98.4062 52.5625 102.573 52.5625 107.712C52.5625 112.852 56.6787 117.018 61.7562 117.018Z",
    fill: "#993030"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.8672,
    y: 97.6172,
    width: 10.0907,
    height: 15.136,
    rx: 5.04535,
    fill: "#EBBAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6029 114.792C74.9418 116.359 75.4713 117.888 76.2744 119.785C76.616 120.592 77.9957 123.67 78.3115 124.407C79.6298 127.483 80.4682 130.022 81.0097 132.91C82.0411 138.411 85.8237 143.011 90.9204 145.723C95.8789 148.362 101.564 148.922 105.944 146.732C108.344 145.532 109.316 142.614 108.116 140.214C106.917 137.815 103.999 136.842 101.599 138.042C100.349 138.667 97.8852 138.424 95.4843 137.146C92.8443 135.742 91.0065 133.506 90.559 131.119C89.8694 127.442 88.818 124.258 87.2414 120.579C86.8805 119.737 85.5128 116.686 85.2215 115.998C84.6348 114.612 84.2871 113.608 84.0991 112.738C83.5321 110.116 80.9467 108.45 78.3244 109.017C75.7021 109.584 74.0359 112.169 74.6029 114.792Z",
    fill: "#EBBAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9972 123.979C27.4958 123.464 27.5017 122.641 28.0105 122.133L44.6857 105.492L52.4722 123.05L38.1211 134.376L27.9972 123.979Z",
    fill: "#2B2D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.725 113.997C40.1547 108.24 44.9506 103.789 50.7229 103.789H54.3368C55.5008 103.789 56.5613 104.458 57.0623 105.509L60.3122 112.323L58.7367 138.319V160.321C58.7367 161.015 58.1954 161.59 57.5017 161.631L38.1487 162.783C37.366 162.83 36.7171 162.184 36.7598 161.401L38.3207 132.805L39.725 113.997Z",
    fill: "#2B2D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5683 112.452L57.1547 102.211L52.2969 103.655L55.3166 116.128L60.5683 112.452Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7719 123.979C96.2734 123.464 96.2675 122.641 95.7586 122.133L79.0834 105.492L71.2969 123.05L85.648 134.376L95.7719 123.979Z",
    fill: "#2B2D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0482 113.997C83.6184 108.24 78.8225 103.789 73.0503 103.789H69.4364C68.2723 103.789 67.2118 104.458 66.7108 105.509L63.4609 112.323L65.0364 138.319V160.321C65.0364 161.015 65.5778 161.59 66.2714 161.631L85.6244 162.783C86.4073 162.83 87.0561 162.184 87.0133 161.401L85.4524 132.805L84.0482 113.997Z",
    fill: "#2B2D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1953 112.452L66.6089 102.211L71.4667 103.655L68.447 116.128L63.1953 112.452Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7472 128.862C67.2547 128.862 67.6662 128.45 67.6662 127.942C67.6662 127.435 67.2547 127.023 66.7472 127.023C66.2396 127.023 65.8281 127.435 65.8281 127.942C65.8281 128.45 66.2396 128.862 66.7472 128.862Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2706 136.869C67.7782 136.869 68.1897 136.458 68.1897 135.95C68.1897 135.443 67.7782 135.031 67.2706 135.031C66.763 135.031 66.3516 135.443 66.3516 135.95C66.3516 136.458 66.763 136.869 67.2706 136.869Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0831 120.854C66.5907 120.854 67.0022 120.442 67.0022 119.935C67.0022 119.427 66.5907 119.016 66.0831 119.016C65.5755 119.016 65.1641 119.427 65.1641 119.935C65.1641 120.442 65.5755 120.854 66.0831 120.854Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.492 153.019C107.647 153.019 110.204 150.521 110.204 147.439C110.204 144.358 107.647 141.859 104.492 141.859C101.338 141.859 98.7812 144.358 98.7812 147.439C98.7812 150.521 101.338 153.019 104.492 153.019Z",
    fill: "#EBBAAA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4006 73.4034C34.8523 73.4034 40.0825 68.4424 40.0825 62.3228C40.0825 56.2031 34.8523 51.2422 28.4006 51.2422C21.9489 51.2422 16.7188 56.2031 16.7188 62.3228C16.7188 68.4424 21.9489 73.4034 28.4006 73.4034Z",
    fill: "#EBBAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1975 74.2627C100.649 74.2627 105.879 69.3018 105.879 63.1821C105.879 57.0625 100.649 52.1016 94.1975 52.1016C87.7458 52.1016 82.5156 57.0625 82.5156 63.1821C82.5156 69.3018 87.7458 74.2627 94.1975 74.2627Z",
    fill: "#EBBAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1379 41.8761C25.8086 22.2894 41.5958 6.23438 61.1854 6.23438C80.7747 6.23438 96.5622 22.2894 96.2327 41.8761L95.7951 67.8899C95.4775 86.7774 80.0755 101.922 61.1854 101.922C42.2951 101.922 26.8931 86.7774 26.5754 67.8899L26.1379 41.8761Z",
    fill: "#EED4CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9141 77.4836L54.4689 80.9868C55.3231 86.3794 60.3869 90.0584 65.7795 89.2044C71.1721 88.3502 74.8513 83.2864 73.9971 77.8938L73.4423 74.3906L53.9141 77.4836Z",
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2463_474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 73,
    width: 22,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8281 76.8378C53.8472 77.0285 53.8718 77.22 53.9022 77.4117L54.4689 80.9893C55.3228 86.3819 60.3869 90.0611 65.7795 89.2071C71.172 88.353 74.8512 83.2891 73.9971 77.8965L73.4304 74.3187C73.4 74.127 73.3644 73.9373 73.3235 73.75L53.8281 76.8378Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2463_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2785 91.7352C69.5305 91.2201 71.9395 89.3677 71.6592 87.5976C71.3788 85.8275 68.5153 84.8101 65.2633 85.3252C62.0113 85.8403 59.6023 87.6927 59.8826 89.4628C60.163 91.2329 63.0265 92.2503 66.2785 91.7352Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.9141,
    y: 77.4844,
    width: 19.7717,
    height: 4.07507,
    transform: "rotate(-9 53.9141 77.4844)",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5963 48.766L52.8725 47.5807C54.1984 47.4413 55.1603 46.2534 55.0209 44.9275C54.8816 43.6016 53.6937 42.6397 52.3678 42.779L41.0916 43.9643C39.7656 44.1037 38.8037 45.2916 38.9431 46.6175C39.0825 47.9435 40.2704 48.9054 41.5963 48.766Z",
    fill: "#393939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3984 55.2656V60.9521C47.3984 62.2853 48.4792 63.3661 49.8125 63.3661C51.1457 63.3661 52.2265 62.2853 52.2265 60.9521V55.2656C52.2265 53.9324 51.1457 52.8516 49.8125 52.8516C48.4792 52.8516 47.3984 53.9324 47.3984 55.2656Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1016 55.2656V60.9521C71.1016 62.2853 72.1824 63.3661 73.5156 63.3661C74.8488 63.3661 75.9297 62.2853 75.9297 60.9521V55.2656C75.9297 53.9324 74.8488 52.8516 73.5156 52.8516C72.1824 52.8516 71.1016 53.9324 71.1016 55.2656Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0213 45.2526L80.2975 46.4379C81.6234 46.5772 82.8113 45.6153 82.9506 44.2894C83.09 42.9635 82.1281 41.7756 80.8022 41.6362L69.526 40.4509C68.2 40.3115 67.0122 41.2734 66.8728 42.5994C66.7334 43.9253 67.6953 45.1132 69.0213 45.2526Z",
    fill: "#393939"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6484 21.5321C23.6484 14.7352 28.5727 8.84876 35.2803 7.75043L66.9978 2.55689C74.894 1.26399 82.3079 6.72009 83.4214 14.6434C84.5184 22.4482 79.0751 29.6624 71.2691 30.7497L39.2933 35.2036C31.0398 36.3939 23.6484 29.871 23.6484 21.5321Z",
    fill: "#393939"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.6094,
    y: 28.7656,
    width: 4.62692,
    height: 24.7439,
    rx: 2.31346,
    fill: "#393939"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8905 29.3656C34.8328 31.2968 31.4531 31.5785 29.0391 41.637L27.4297 31.5785C32.1908 30.0363 40.9483 27.4343 37.8905 29.3656Z",
    fill: "#393939"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2031,
    y: 31.7891,
    width: 4.62692,
    height: 24.5428,
    rx: 2.31346,
    fill: "#393939"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.8828,
    y: 10.6328,
    width: 20.5852,
    height: 30.6121,
    rx: 10.2926,
    transform: "rotate(-20.5 70.8828 10.6328)",
    fill: "#393939"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8951 0C75.3453 7.07079 75.3047 15.1359 75.3047 15.1359L86.3743 7.62319C86.3743 7.62319 80.6194 6.18693 75.8951 0Z",
    fill: "#393939"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4531 40.2811C33.3926 34.4946 34.6382 31.5977 33.3926 26.9531H95.6206V44.2538L92.1049 42.3004C92.1049 35.9567 85.005 38.376 81.1798 34.4946C75.0855 28.3106 68.179 34.9382 64.1672 38.9306C64.1672 34.0508 61.8365 34.1619 59.7839 33.1639C60.0825 37.7773 52.6555 40.8381 47.6173 40.8381C47.6173 35.8477 47.6554 36.1581 45.4161 34.4946C40.646 36.1104 37.9157 34.4946 32.4531 40.2811Z",
    fill: "#393939"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8446 69.408C52.5665 69.408 57.2049 64.7696 57.2049 59.0478C57.2049 53.326 52.5665 48.6875 46.8446 48.6875C41.1228 48.6875 36.4844 53.326 36.4844 59.0478C36.4844 64.7696 41.1228 69.408 46.8446 69.408Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3993 69.6034C80.1212 69.6034 84.7596 64.9649 84.7596 59.2431C84.7596 53.5213 80.1212 48.8828 74.3993 48.8828C68.6775 48.8828 64.0391 53.5213 64.0391 59.2431C64.0391 64.9649 68.6775 69.6034 74.3993 69.6034Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0128 59.0728C58.0128 65.145 53.0903 70.0675 47.0181 70.0675C40.9459 70.0675 36.0234 65.145 36.0234 59.0728C36.0234 53.0006 40.9459 48.0781 47.0181 48.0781C53.0903 48.0781 58.0128 53.0006 58.0128 59.0728ZM38.0347 59.0723C38.0347 64.0335 42.0565 68.0553 47.0176 68.0553C51.9788 68.0553 56.0006 64.0335 56.0006 59.0723C56.0006 54.1112 51.9788 50.0893 47.0176 50.0893C42.0565 50.0893 38.0347 54.1112 38.0347 59.0723Z",
    fill: "#2E2622"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3175 59.5884C85.3175 65.6606 80.395 70.5831 74.3228 70.5831C68.2506 70.5831 63.3281 65.6606 63.3281 59.5884C63.3281 53.5162 68.2506 48.5938 74.3228 48.5938C80.395 48.5938 85.3175 53.5162 85.3175 59.5884ZM65.3393 59.5879C65.3393 64.5491 69.3612 68.5709 74.3223 68.5709C79.2835 68.5709 83.3053 64.5491 83.3053 59.5879C83.3053 54.6268 79.2835 50.605 74.3223 50.605C69.3612 50.605 65.3393 54.6268 65.3393 59.5879Z",
    fill: "#2E2622"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9658 60.0507L64.3526 60.1151C64.9081 60.1199 65.3623 59.6736 65.3672 59.1181C65.372 58.5626 64.9256 58.1083 64.3701 58.1035L56.9834 58.0391C56.4279 58.0343 55.9736 58.4807 55.9688 59.0361C55.9639 59.5916 56.4103 60.0459 56.9658 60.0507Z",
    fill: "#2E2622"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2134 60.5234C58.1482 60.9983 58.0744 61.3193 57.7245 62.7237C57.6397 63.0642 57.5795 63.3113 57.5218 63.5593C57.0936 65.3974 56.9613 66.6539 57.2413 67.8213C57.6812 69.6549 59.1384 70.712 61.2816 70.712V67.2921C61.0614 67.2921 60.8894 67.2716 60.7634 67.2376C60.6892 67.2176 60.648 67.1984 60.6275 67.1836C60.6134 67.1734 60.596 67.1449 60.5669 67.0235C60.4498 66.5356 60.5405 65.6745 60.8525 64.3351C60.9055 64.1075 60.9621 63.8754 61.043 63.5503C61.4321 61.9883 61.5119 61.6415 61.6015 60.9883L58.2134 60.5234Z",
    fill: "#EBBAAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.463c09dd9f7eec8803fe3a19c02bc357.svg";
export { ForwardRef as ReactComponent };